<template>
  <div class="muteng-claim-result-container">
    <img class="logo" src="/static/images/muteng/logo.png" />
    <div v-if="joinStatus === 1" class="content">
      <div class="rule-box">
        <div class="rule-top">
          <img src="/static/images/muteng/gongxi.png" class="gongxi-img" />
          <img src="/static/images/muteng/happy.png" class="happy-img" />
        </div>
        <div class="points-row">
          <span class="points-num">{{ points }}积分</span>
        </div>
        <div class="rule-bottom">
          <div class="en-title-box">
            <img src="/static/images/muteng/gongxi-en.png" class="gongxi-en-img" />
          </div>
          <div class="rule-shop">
            <wx-open-launch-weapp
              class="shop-launch-btn"
              :appid="miniAppId"
              :username="miniAppOriginalId"
              :path="miniAppPage">
              <script type="text/wxtag-template">
                <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/shop/go-shop-9c08da9fbb97460f819b655eb290cda2.png" style="width: 100%; height: auto; display: block;" />
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>

    <div v-if="joinStatus === 2" class="claim-result-content">
      <div class="claim-result-box">
        <div class="claim-result-top">
          <img src="/static/images/muteng/sorry.png" class="claim-result-title-img" />
          <img src="/static/images/muteng/no-happy.png" class="claim-result-extra-img" />
        </div>
        <div class="claim-result-bottom">
          <div class="claim-result-claim">
            <img src="/static/images/muteng/points-mall.png" class="claim-result-points-img" />
          </div>
          <div class="claim-result-shop">
            <wx-open-launch-weapp
              class="claim-result-shop-launch-btn"
              :appid="miniAppId"
              :username="miniAppOriginalId"
              :path="miniAppPage">
              <script type="text/wxtag-template">
                <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/shop/go-shop-9c08da9fbb97460f819b655eb290cda2.png" style="width: 100%; height: auto; display: block;" />
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-text" @click="toRule">规则说明</div>
  </div>
</template>

<script>
import { getJSSDK, getTemplateV2, getScoreConfig, registerByOpenId, joinActivity } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'MuTengClaimResult',
  data() {
    return {
      eno: '',
      code: '',
      deptId: '',
      wyAuthCode: '',
      activityId: '',
      userToken: '',
      joinStatus: 0,
      points: '',
      appId: process.env.ENV_NUM === '1' ? 'wxc537e3c625581d97' : 'wxbc22565b3e7a59fd',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: ''
    }
  },
  methods: {
    async queryTemplate() {
      const res = await getTemplateV2(this.deptId, this.code)
      this.activityId = (res && res.data && res.data.data ? res.data.data.activityId : '')
    },
    async queryScoreConfig() {
      const res = await getScoreConfig(this.deptId)
      if (res && res.data && res.data.data) {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
      }).catch(err =>
        alert('获取微信授权失败' + err)
      )
    },
    async registerUser() {
      const res = await registerByOpenId(this.eno, this.wyAuthCode)
      if (res && res.data && res.data.code === '200' && res.data.data && res.data.data.token) {
        this.userToken = res.data.data.token
      } else {
        alert(res && res.data && res.data.message ? res.data.message : '用户注册失败，请重试')
      }
    },
    async joinCurrentActivity() {
      const data = {
        code: this.code,
        activityId: this.activityId,
        authCode: this.wyAuthCode,
        userToken: this.userToken
      }
      const res = await joinActivity(data)
      if (res && res.data && res.data.code === '200' && res.data.data) {
        this.points = res.data.data.giftValue
        this.joinStatus = 1
      } else if (res && res.data && res.data.code === '500001' && res.data.data) {
        this.points = res.data.data.giftValue
        this.joinStatus = 2
      } else {
        alert(res && res.data && res.data.message ? res.data.message : '参与活动失败，请联系客服处理')
      }
    },
    toRule() {
      this.$router.push({
        path: '/muteng/rule',
        query: {
          deptId: this.deptId,
          code: this.code
        }
      })
    }
  },
  async mounted() {
    const params = this.$route.query
    this.eno = params.eno || ''
    this.code = params.c || ''
    this.deptId = params.deptId || ''
    this.wyAuthCode = params.wyAuthCode || ''
    await this.queryTemplate()
    if (!this.activityId) {
      alert('暂无可参与的活动，请耐心等待下期活动')
      return
    }
    await this.queryScoreConfig()
    this.getWxJs()
    await this.registerUser()
    if (!this.userToken) {
      return
    }
    await this.joinCurrentActivity()
  }
}
</script>

<style scoped>
.muteng-claim-result-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
  background-image: url('/static/images/muteng/bg2.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.logo {
  position: absolute;
  top: 5vh;
  right: 7vw;
  width: 35vw;
  z-index: 10;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.content {
  position: relative;
  z-index: 5;
}

.claim-result-content {
  position: relative;
  z-index: 5;
}

.claim-result-box {
  position: absolute;
  top: 65vh;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.claim-result-top {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2vh;
}

.claim-result-title-img {
  width: 50vw;
}

.claim-result-extra-img {
  width: 7vw;
  height: 7vw;
  margin-left: 4vw;
  margin-top: 2.3vh;
  object-fit: contain;
  align-self: center;
  display: block;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.claim-result-bottom {
  width: 100%;
  display: flex;
  margin-top: 1vh;
  justify-content: space-between;
  align-items: flex-end;
}

.claim-result-claim {
  flex: 1;
  padding-right: 2vw;
}

.claim-result-points-img {
  width: 28vw;
  display: block;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.claim-result-shop {
  display: flex;
  align-items: flex-end;
}

.shop-launch-btn {
  width: 15vw;
  display: block;
  line-height: 0;
}

.claim-result-shop-launch-btn {
  width: 13vw;
  display: block;
  line-height: 0;
}

.claim-result-shop-img {
  width: 13vw;
  display: block;
}

.rule-box {
  position: absolute;
  top: 65vh;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rule-top {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 1vh;
}

.gongxi-img {
  width: 25vw;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.happy-img {
  width: 6.5vw;
  margin-left: 17vw;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.rule-shop {
  display: flex;
  margin-top:-6vh;
  align-items: flex-end;
}

.points-row {
  width: 100%;
  text-align: left;
  margin-bottom: 1vh;
}

.points-num {
  color: rgb(255,229,118);
  font-size: 13vw;
  font-weight: bold;
}

.rule-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.en-title-box {
  flex: 1;
}

.gongxi-en-img {
  width: 50vw;
  display: block;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.shop-img {
  width: 12vw;
  display: block;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  margin-top:-7vh;
}

.footer-text {
  position: absolute;
  bottom: 3vh;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  cursor: pointer;
  font-size: 3.5vw;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/MuTeng/ClaimResult.vue